import { getGlobalHeadersAsObject } from "../global-headers";

export interface ProfileBinaryItem {
	id: number;
	created: string;
	profile_type: number;
	profile_type_label: string;
	extracted: boolean;
}

export interface ProfileBinaryDetail {
	id: number;
	created: string;
	profile_type: number;
	profile_type_label: string;
	extracted: boolean;
	json_data: Record<string, unknown> | null;
}

export interface ProfileBinaryResponse {
	results: ProfileBinaryItem[];
}

export async function getPersonProfileBinaries(
	personId: number
): Promise<ProfileBinaryResponse> {
	const response = await fetch(`/api/v2/persons/${personId}/profile_binaries/`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			...getGlobalHeadersAsObject(),
		},
	});

	if (!response.ok) {
		throw new Error(`Failed to fetch profile binaries: ${response.status}`);
	}

	return response.json();
}

export async function getProfileBinaryDetail(
	binaryId: number
): Promise<ProfileBinaryDetail> {
	const response = await fetch(`/api/v2/persons/profile_binary/${binaryId}/`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			...getGlobalHeadersAsObject(),
		},
	});

	if (!response.ok) {
		throw new Error(`Failed to fetch profile binary detail: ${response.status}`);
	}

	return response.json();
}
